import script from "./QuizSidebarTile.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizSidebarTile.vue?vue&type=script&setup=true&lang=js"

import "./QuizSidebarTile.vue?vue&type=style&index=0&id=c7529674&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7529674"]])

export default __exports__